import { render, staticRenderFns } from "./FeatureSelection.vue?vue&type=template&id=2c098da2&"
import script from "./FeatureSelection.script.js?vue&type=script&lang=js&"
export * from "./FeatureSelection.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports